import { login,getUserInfo } from '@/api/login'
import { getToken, setToken, removeToken } from '@/utils/storage'
const user = {
    state: {
        token: getToken(),
        name: null,
        app_id:null,
        shopkey:null
    },
    mutations: {
        SET_TOKEN: (state, token) => {
            state.token = token
        },
        setShopkey: (state, key) => {
            state.shopkey = key
        },
    },
    actions: {
        // 登录
        Login({ commit }, data) {
            const { mobile,password,app_id } = data
            return new Promise((resolve, reject) => {
                login({mobile, password,app_id}).then(response => {
                    if (response.code == 1) {
                        const data = response.data
                        setToken(data.token)
                        commit('SET_TOKEN', data.token)
                        resolve(data)
                    } else {
                        reject(response.msg)
                    }
                }).catch(error => {
                    reject(error)
                })
            })
        },
        userInfo({commit},data){
        },
        LoginOut({ commit }){
            removeToken()
            commit('SET_TOKEN', '')
            // 同步清理可能的本地缓存用户信息
            try {
                localStorage.removeItem('userInfo')
                localStorage.removeItem('userDetail')
            } catch (e) {}
        }
    }
}
export default user
